import { CSSProperties } from 'react';
import {
  COLORS,
  DISPLAY_STRETCH,
  FONTS,
  GLASS,
  META,
} from '../../../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '1.25rem',
    marginTop: '3rem',
  },
  card: {
    ...GLASS,
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '2rem 1.75rem',
    border: `1px solid ${COLORS.border}`,
    textDecoration: 'none',
    color: COLORS.text,
  },
  glyph: {
    width: '2.25rem',
    height: '2.75rem',
    color: COLORS.accent,
  },
  title: {
    fontFamily: FONTS.display,
    fontStretch: DISPLAY_STRETCH,
    fontWeight: 600,
    fontSize: '1.6rem',
    lineHeight: 1.1,
  },
  summary: {
    fontSize: '1rem',
    lineHeight: 1.7,
    color: COLORS.muted,
    flex: 1,
  },
  action: {
    fontFamily: FONTS.body,
    fontWeight: 600,
    fontSize: '1rem',
    color: COLORS.accent,
    textDecoration: 'underline',
    textUnderlineOffset: '4px',
  },
  address: {
    ...META,
    fontSize: '0.66rem',
    textTransform: 'none',
    letterSpacing: '0.04em',
    color: COLORS.label,
    overflowWrap: 'anywhere',
  },
  note: {
    marginTop: '1.5rem',
    maxWidth: '40rem',
    fontSize: '1rem',
    lineHeight: 1.7,
    color: COLORS.muted,
  },
};
